export const stats = [
  { value: '1000+', label: 'Produktów', icon: 'ri-shopping-bag-3-line' },
  { value: '50+', label: 'Kategorii', icon: 'ri-folder-line' },
  { value: '60+', label: 'Poradników', icon: 'ri-book-open-line' },
  { value: '24/7', label: 'Dostęp', icon: 'ri-time-line' },
];